"use strict";
/* tslint:disable */
module.exports = [
    /**
     * Homepage
     */
    {
        path: '/',
        name: 'home',
        component: function () { return import(/* webpackChunkName: 'main-group' */ 'Views/Home/Home.vue'); },
        meta: {
            requiresAuth: true,
            title: '',
        },
    },
    /**
     * Search
     */
    {
        path: '/search/:term',
        component: function () { return import(/* webpackChunkName: 'main-group' */ 'Views/Search/Search.vue'); },
        meta: {
            requiresAuth: true,
            title: 'Search',
        },
    },
    /**
     * Comments
     */
    {
        path: '/comments',
        component: function () { return import(/* webpackChunkName: 'main-group' */ 'Views/Comments/Comments.vue'); },
        meta: {
            requiresAuth: true,
            title: 'Replies',
        },
    },
];
/* tslint:enable */



// WEBPACK FOOTER //
// ./~/ts-loader??ref--3!./src/js/Router/Routes/BaseRoutes.ts